module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vcenter-content",
    attrs: {
      "id": "screensaver"
    }
  }, [(_vm.siteIntro) ? _c('marque', {
    staticClass: "vcenter"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "longfade"
    }
  }, [(!_vm.siteIntro) ? _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTagline),
      expression: "showTagline"
    }],
    staticClass: "h5 century-mono vcenter"
  }, [_vm._v("\n      Contemporary Products,"), _c('br'), _vm._v("\n      Traditional Craftsmanship,"), _c('br'), _vm._v(" \n      Designed and"), _c('br'), _vm._v("\n      Conceived in London\n    ")]) : _vm._e()]), _vm._v(" "), (!_vm.siteIntro) ? _c('cinemagraph', {
    attrs: {
      "blur": true,
      "lowRes": _vm.sleepMode,
      "site": _vm.site
    },
    on: {
      "playing": function($event) {
        _vm.showTagline = true
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4190308d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Screensaver.vue
// module id = 382
// module chunks = 1